import styled from "styled-components";

export const FormInput = styled.button`
  font-family: 'PoppinsBold', sans-serif;
  font-size: 16px;
  height: 47px;
`;